// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 618) return "static/chunks/618.21e885eb309b69d2.js";
	if (chunkId === 281) return "static/chunks/281.144888ed3cc6a9bb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"57671f315ae3f6d7","431":"29564a12b8cca8e4","528":"93a1c98a6e4d6a38","704":"7a39f83f8b62f786","939":"163c022470a9e51a","979":"6d01c81df8ab43bd"}[chunkId] + ".js";
};